import { HOME_PAGE_ACTIONS } from "./actionTypes";
import { axiosHomeScreen, axiosContentDetail } from "../axios";
import { getCurrentSlide } from "../util/commonFunctions"
import { getContentWithLanguage } from "../util/language";
import { handleActionError } from "../util/error";

let homePageStructureCache = null;
let epgCache = null;
let liveStreamDataCache = null;

export const invalidateCache = () => {
  console.log("Invalidating cache...");
  homePageStructureCache = null;
  epgCache = null;
  liveStreamDataCache = null;
  console.log("Cache invalidated successfully.");
}

export const getHomePageStructureInitialLoad = (language) => async (
  dispatch
) => {
  try {
    // TODO this caching will need to accept the language as a parameter
    if (homePageStructureCache){
      console.log("Returning home page structure cache for TODAY...");
      return dispatch({
        type: HOME_PAGE_ACTIONS.HOME_PAGE_STRUCTURE._SUCCESS,
        payload: { data: homePageStructureCache }
      });
    } 
    console.log("No cache found for today, returning TODAY response from API...");
    let startTime = new Date().getTime();
    const homeStructureData = await axiosHomeScreen.get("/TODAY");
    let duration = new Date().getTime() - startTime;
    console.log(`Request: /TODAY on: getHomePageStructureInitialLoad() took: ${duration} ms`);
    const filteredByLanguage = getContentWithLanguage(homeStructureData.data.rows, language);
    console.log("Setting cache to filteredByLanguage...");
    homePageStructureCache = filteredByLanguage;
    dispatch({
      type: HOME_PAGE_ACTIONS.HOME_PAGE_STRUCTURE._SUCCESS,
      payload: { data: filteredByLanguage }
    });
  } catch (error){
    handleActionError("Error fetching home page data:", error);
  }
};

export const getEpgInitialLoad = (language) => async (dispatch, getState, api) => {

  try {
      let now = new Date(),
      today = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0
      ).getTime();


    let reqBody = {
      "token": null
    }
    let reqHeaders = {
      "Accept-Language": language
    }

    let resp = null;
    if (epgCache != null && epgCache[today]){
      console.log("Returning EPG cache for date: ", today, new Date(today));
      resp = epgCache[today];
    } else {
      console.log(`No cache found for date: ${today}-${new Date(today)}, returning live stream data from API....`);
      const startTime = new Date().getTime();
      const epgData = await axiosContentDetail.post("/api/v2/epg?date=" + today, reqBody, {headers: reqHeaders});
      const duration = new Date().getTime() - startTime;
      console.log(`EPG request took: ${duration} ms`);
      resp = epgData;
      console.log("Setting EPG Cache to epg response for date: ", today, new Date(today));
      if (epgCache == null){
        epgCache = {}
      }
      epgCache[today] = resp;
    }

    const slideNum = getCurrentSlide(resp.data.data.today)
    
    let data = resp.data.data;
    data.slideNumber = slideNum
    dispatch({
      type: HOME_PAGE_ACTIONS.EPG_DATA._SUCCESS,
      payload: { data: data }
    }); 
  } catch (err){
    handleActionError("Error fetching EPG", err);
  }
};

export const getLiveStreamDataInitialLoad = () => async (
  dispatch,
  getState,
  api
) => {
  try {
    if (liveStreamDataCache != null){
      console.log("Returning live stream cache...");
      return dispatch({
        type: HOME_PAGE_ACTIONS.LIVE_STREAM._SUCCESS,
        payload: { data: liveStreamDataCache }
      });
    }
    console.log("No cache found for live-stream data, returning live stream data from API....");
    const startTime = new Date().getTime();
    const liveStreamData = await axiosContentDetail.get("/api/v1/liveStream");
    const duration = new Date().getTime() - startTime;
    console.log(`Duration of live stream data request took: ${duration} ms`);
    console.log("Setting cache of live stream....")
    liveStreamDataCache = liveStreamData.data.data;
    dispatch({
      type: HOME_PAGE_ACTIONS.LIVE_STREAM._SUCCESS,
      payload: { data: liveStreamData.data.data }
    });
  } catch (err){
    handleActionError("Error fetching live stream data:", err);
  }
};

export const resetEpgData = () => {
  return dispatch => {
    dispatch({
      type: HOME_PAGE_ACTIONS.EPG_DATA._START
    });
  };
};

export const getHomePageStructure = (language) => {
  return dispatch => {
    dispatch({
      type: HOME_PAGE_ACTIONS.HOME_PAGE_STRUCTURE._START
    });
    const startRequest = new Date().getTime();
    return axiosHomeScreen
      .get("/TODAY")
      .then(response => {
        const { data = {} } = response;
        const duration = new Date().getTime() - startRequest;
        console.log(`Request: /TODAY in: getHomePageStructure() took: ${duration} ms`);
        const filteredByLanguage = getContentWithLanguage(data.rows, language);
        
        dispatch({
          type: HOME_PAGE_ACTIONS.HOME_PAGE_STRUCTURE._SUCCESS,
          payload: { data: filteredByLanguage }
        });
      })
      .catch(error => {
        handleActionError("An error occurred retrieving home page data", error);
        dispatch({
          type: HOME_PAGE_ACTIONS.HOME_PAGE_STRUCTURE._FAILURE
        });
      });
  };
};

export const getEpg = (token, language) => {
  let now = new Date(),
    today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    ).getTime();
  return dispatch => {
    dispatch({
      type: HOME_PAGE_ACTIONS.EPG_DATA._START
    });
    let reqBody = {
      "token": token
    }
    let reqHeaders = {
      "Accept-Language": language
    }
    return axiosContentDetail
      .post("/api/v2/epg?date=" + today, reqBody, {headers: reqHeaders})
      .then(response => {
        const { data = {} } = response;
        const slideNum = getCurrentSlide(data.data.today)
        let Itemdata = data.data;
        Itemdata.slideNumber = slideNum
        dispatch({
          type: HOME_PAGE_ACTIONS.EPG_DATA._SUCCESS,
          payload: { data: Itemdata }
        });
      })
      .catch(error => {
        handleActionError("An error occurred retrieving EPG data", error);
        dispatch({
          type: HOME_PAGE_ACTIONS.EPG_DATA._FAILURE
        });
      });
  };
};

export const getLiveStreamData = () => {
  return dispatch => {
    dispatch({
      type: HOME_PAGE_ACTIONS.LIVE_STREAM._START
    });
    return axiosContentDetail
      .get("/api/v1/liveStream")
      .then(response => {
        const { data = {} } = response;
        dispatch({
          type: HOME_PAGE_ACTIONS.LIVE_STREAM._SUCCESS,
          payload: { data: data.data }
        });
      })
      .catch(error => {
        handleActionError("An error occurred fetching live stream data", error);
        dispatch({
          type: HOME_PAGE_ACTIONS.LIVE_STREAM._FAILURE
        });
      });
  };
};

export const getAutoRailHome = (url, noVod, index) => {
  return dispatch => {
    dispatch({
      type: HOME_PAGE_ACTIONS.AUTO_RAIL._START,
      payload: { index: index }
    });
    return axiosContentDetail
      .get(`${url}?offset=0&max=${noVod}`)
      .then(response => {
        let { data = {} } = response;
        if (Array.isArray(data.data)) {
          data = data.data;
        } else {
          data = data.data.items[0].contentResults;
        }
        dispatch({
          type: HOME_PAGE_ACTIONS.AUTO_RAIL._SUCCESS,
          payload: { data: data, index: index }
        });
      })
      .catch(error => {
        handleActionError("An error occurred fetching auto rail data", error);
        dispatch({
          type: HOME_PAGE_ACTIONS.AUTO_RAIL._FAILURE,
          payload: { index: index }
        });
      });
  };
};
